<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30 distributor-page">
    <div>
      <div class="list-wrap mg-b-15">
        <div class="list-heard d-flex mg-b-5">
          <div class="d-flex justify-content-center">
            <label class="ckbox mg-b-0">
              <input
                type="checkbox"
                :checked="isAll"
                @change="checkAll($event)"
              /><span></span>
            </label>
          </div>
          <div class="d-flex pd-x-5 flex-1 tx-white">
            <div class="c-6">{{ $t("distributor.客户") }}</div>
            <div class="c-5">{{ $t("mall.地址") }}</div>
            <div class="c-5">{{ $t("distributor.联系人") }}</div>
            <div class="c-5">{{ $t("distributor.业务员") }}</div>
            <div class="c-3">{{ $t("distributor.操作") }}</div>
          </div>
        </div>
        <div
          class="list-body d-flex align-items-center mg-b-10"
          v-for="(item, index) in items"
          :key="'item' + index"
        >
          <div class="d-flex justify-content-center">
            <label class="ckbox mg-b-0">
              <input
                type="checkbox"
                :value="item.id"
                v-model="checkArr"
              /><span></span>
            </label>
          </div>
          <div class="flex-1 pd-x-0 mg-x-5">
            <div class="card bd-gray-400 pd-5">
              <div
                class="d-flex flex-row align-items-center justify-content-start"
              >
                <!-- 客户 -->
                <div class="c-6">{{ item.name }}</div>
                <!-- 地址 -->
                <div class="c-5">{{ item.address || "---" }}</div>
                <!-- 联系人 -->
                <div class="c-5">
                  <div>
                    <span class="tx-gray-300">{{
                      item.contacts || "---"
                    }}</span>
                    <a
                      v-if="item.contacts"
                      href="javascript:;"
                      :data-clipboard-text="item.contacts"
                      class="to-clipboard"
                    >
                      <i class="icon ion-clipboard"></i>
                    </a>
                  </div>
                  <div>
                    <span class="mg-r-5">{{ $t("distributor.电话:") }}</span>
                    <span class="tx-gray-300">{{ item.phone || "---" }}</span>
                    <a
                      v-if="item.phone"
                      href="javascript:;"
                      :data-clipboard-text="item.phone"
                      class="to-clipboard"
                    >
                      <i class="icon ion-clipboard"></i>
                    </a>
                  </div>
                  <div>
                    <span class="mg-r-5">{{ $t("distributor.邮箱:") }}</span>
                    <span class="tx-gray-300">{{ item.email || "---" }}</span>
                    <a
                      v-if="item.email"
                      href="javascript:;"
                      :data-clipboard-text="item.email"
                      class="to-clipboard"
                    >
                      <i class="icon ion-clipboard"></i>
                    </a>
                  </div>
                  <div>
                    <span class="mg-r-5">QQ:</span>
                    <span class="tx-gray-300">{{ item.qq || "---" }}</span>
                    <a
                      v-if="item.qq"
                      href="javascript:;"
                      :data-clipboard-text="item.qq"
                      class="to-clipboard"
                    >
                      <i class="icon ion-clipboard"></i>
                    </a>
                  </div>
                </div>
                <!-- 业务员 -->
                <div class="c-5">---</div>
                <!-- 操作 -->
                <div class="c-3">
                  <div>
                    <a
                      v-if="isSysRights('SupplierProductStock.editRawSupplier')"
                      class="tx-info"
                      href="javascript:;"
                      @click="editRawSupplier(item)"
                      >{{ $t("distributor.编辑") }}</a
                    >
                  </div>
                  <div>
                    <a
                      v-if="isSysRights('SupplierProductStock.delRawSupplier')"
                      class="tx-info"
                      href="javascript:;"
                      @click="delRawSupplier(item.id)"
                      >{{ $t("distributor.删除") }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="(!items || items.length < 1) && !first_loading"
          class="col-12 none-product"
        >
          <i class="fa fa-ban"></i
          >{{ $t("distributor.没有符合条件的合作客户") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items", "check_arr"],
  data() {
    return {
      checkArr: [],
    };
  },
  computed: {
    isAll() {
      return this.checkArr.length == this.items.length && this.items.length > 0
        ? true
        : false;
    },
  },
  watch: {
    check_arr: function () {
      this.checkArr = this.check_arr;
    },
    checkArr: function () {
      this.$parent.checkArr = this.checkArr;
    },
  },
  methods: {
    checkAll(e) {
      this.checkArr = [];
      if (e.target.checked) {
        this.items.forEach((e) => {
          this.checkArr.push(e.id);
        });
      }
    },
    // 编辑供应商信息
    editRawSupplier(item) {
      this.$parent.modalDidtributor = JSON.parse(
        this.$parent.modalDidtributorDefault
      );
      this.$parent.modalDidtributor.open = Symbol();
      this.$parent.modalDidtributor.info = item;
      $("#modalDidtributor").modal("show");
    },
    // 删除供应商
    delRawSupplier(id) {
      this.$parent.loading = true;
      $.api_call(
        "api.SupplierProductStock.delRawSupplier",
        {
          id,
        },
        (r) => {
          this.$parent.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("rm.删除客户成功"), "success");
            this.$parent.getDistributor();
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(vm);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
  },
};
</script>